// Iter-276.G (Top-20 #20) — RateCell extracted from PartnerRateTable.jsx
// as part of the LoC refactor. Single-spec key/value cell used inside
// each mobile lender card (3-4 cells per card). The `dominant` variant
// lifts the conversion-driving spec (APR for credit verticals, premium
// for insurance) above the supporting specs.

import React from "react";

export default function RateCell({ label, value, bold, dominant }) {
  // Iter-155 (Phase-3) — `dominant` lifts the primary spec per vertical
  // (APR for loans/refinance) to a larger font weight on mobile cards.
  // Visual hierarchy: the conversion-driving number lands the user's eye
  // first; supporting specs render at standard scale around it.
  if (dominant) {
    return (
      <div
        data-testid="rate-cell-dominant"
        className="col-span-2 pb-2 mb-1 border-b border-slate-200"
      >
        <dt className="text-[10px] uppercase tracking-[0.15em] text-slate-500 font-semibold">
          {label}
        </dt>
        <dd className="mt-0.5 font-display font-black text-2xl text-slate-950 leading-tight tabular-nums">
          {value}
        </dd>
      </div>
    );
  }
  return (
    <div>
      <dt className="text-[10px] uppercase tracking-[0.15em] text-slate-500 font-semibold">
        {label}
      </dt>
      <dd className={`mt-0.5 ${bold ? "font-display font-bold text-slate-950" : "text-slate-700"}`}>
        {value}
      </dd>
    </div>
  );
}
